'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by zfc on 2017/2/25.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import {Link} from 'react-router';
// import FlipCard from '../FlipCard/FlipCard';

var WorkStationFilterBar = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(WorkStationFilterBar, _Component);

  function WorkStationFilterBar() {
    (0, _classCallCheck3.default)(this, WorkStationFilterBar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(WorkStationFilterBar).call(this));

    _this.state = {
      isOpened: false,
      itemHeaderId: '00'
    };
    return _this;
  }

  (0, _createClass3.default)(WorkStationFilterBar, [{
    key: 'onItemHeaderClick',
    value: function onItemHeaderClick(id) {
      this.setState({
        itemHeaderId: id
      });
    }
  }, {
    key: 'itemClick',
    value: function itemClick(id) {
      var onItemClick = this.props.onItemClick;

      if (onItemClick) {
        var sTop = document.documentElement.scrollTop + document.body.scrollTop;
        onItemClick(id);
        window.scrollTo(0, sTop);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./WorkStationFilterBar.scss');
      var data = this.props.data;
      var itemHeaderId = this.state.itemHeaderId;

      var designerFilterDiv = '';
      var thirdHeaderArray = [{ id: '00', name: '全部' }, { id: '01', name: '华东' }, { id: '02', name: '华北' }, { id: '03', name: '华中' }, { id: '04', name: '华南' }, { id: '05', name: '西南' }, { id: '06', name: '西北' }, { id: '07', name: '东北' }];
      var thirdItemArray = [];
      if (data instanceof Array) {
        data.forEach(function (currentItem, index) {
          if (itemHeaderId === '00') {
            thirdItemArray.push(_react2.default.createElement(
              'li',
              { key: index, className: styles.thirdItemText,
                onClick: function onClick() {
                  return _this2.itemClick(currentItem.provinceId);
                } },
              currentItem.province
            ));
          } else {
            var currentThirdHeader = thirdHeaderArray.find(function (item) {
              return item.id === itemHeaderId;
            });
            if (currentThirdHeader && currentItem.groupId.length > 0 && currentThirdHeader.id === currentItem.groupId) {
              thirdItemArray.push(_react2.default.createElement(
                'li',
                { key: index, className: styles.thirdItemText,
                  onClick: function onClick() {
                    return _this2.itemClick(currentItem.provinceId);
                  } },
                currentItem.province
              ));
            }
          }
        });
        designerFilterDiv = _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: styles.thirdItem },
            _react2.default.createElement(
              'div',
              { className: styles.thirdHeader },
              thirdHeaderArray instanceof Array ? thirdHeaderArray.map(function (currentItem, index) {
                var currentItemClass = styles.shaixuan_zimu;
                if (currentItem.id === itemHeaderId) {
                  currentItemClass = styles.shaixuan_zimu + ' ' + styles.active;
                }
                return _react2.default.createElement(
                  'div',
                  { key: index, onClick: function onClick() {
                      return _this2.onItemHeaderClick(currentItem.id);
                    },
                    className: currentItemClass },
                  currentItem.name
                );
              }) : ''
            ),
            _react2.default.createElement('div', { className: 'clear' }),
            _react2.default.createElement(
              'div',
              { style: { width: '100%', height: 37 } },
              _react2.default.createElement(
                'ul',
                null,
                thirdItemArray
              )
            )
          )
        );
      }

      return _react2.default.createElement(
        'div',
        { className: styles.component },
        designerFilterDiv
      );
    }
  }]);
  return WorkStationFilterBar;
}(_react.Component), _class.propTypes = {
  data: _react.PropTypes.array,
  onItemClick: _react.PropTypes.func
}, _temp);
exports.default = WorkStationFilterBar;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/WorkStationFilterBar/WorkStationFilterBar.js
 ** module id = 1434
 ** module chunks = 0
 **/